<template>
  <div class="d-inline-block text-secondary qtm-body pa-1 status text-no-wrap">
    <div class="d-flex align-center">
      <v-icon v-if="statusIcon" class="mr-2">
        {{ statusIcon }}
      </v-icon>
      <q-icon v-else class="mr-2" />
      {{ status }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Order } from '@quotetome/materials-api'
import QIcon from '@/components/q-icon.vue'

export interface Props {
  order: Order
}

const props = defineProps<Props>()

const status = computed(() => {
  return props.order.status
})

const statusIcon = computed<string | undefined>(() => {
  const iconMap: { [key: string]: string } = {
    'Cancelled': 'mdi-close-circle-outline',
    'Complete': 'mdi-check',
    'Draft PO': 'mdi-information-outline',
    'Incomplete PO': 'mdi-information-outline',
    'On Order': 'mdi-truck-outline',
    'Partially Received': 'mdi-circle-slice-5',
    'Change Order Pending': 'mdi-clock-outline',
    'Sent for Signature': 'ms:ink_pen',
    'Awaiting Approval': 'mdi-clock-outline',
    'Quotes Requested': 'mdi-clock-outline',
    'Quoting Done': 'mso:shoppingmode',
  }

  return iconMap[status.value]
})
</script>

<style lang="scss" scoped>
.status {
  border-radius: 2px;
  background: rgba(92, 129, 151, 0.20);
}
</style>
